'use client';

import {
	Checkbox as ChakraCheckbox,
	CheckboxGroup as ChakraCheckboxGroup,
	Fieldset,
} from '@chakra-ui/react';
import type { FieldsetContentProps } from '@chakra-ui/react';
import { useController, useFormContext } from 'react-hook-form';

import type { FormFieldsetProps, FormValues } from '../../../types';
import { FormFieldset } from '../../wrapper';

export type CheckboxGroupProps<T> = FormFieldsetProps<T> & {
	direction?: 'horizontal' | 'vertical'
	items: {
		label: string
		value: string
	}[]
} & FieldsetContentProps;

export const CheckboxGroup = <T extends FormValues>({
	helperText,
	items,
	label,
	name,
	...props
}: CheckboxGroupProps<T>) => {
	const { control } = useFormContext();
	const controller = useController({
		control,
		name,
	});
	const { onChange, value } = controller.field;

	return (
		<FormFieldset helperText={helperText} label={label} name={name}>
			<ChakraCheckboxGroup name={name} onValueChange={onChange} value={value}>
				<Fieldset.Content {...props}>
					{items.map(item => (
						<ChakraCheckbox.Root key={item.value} value={item.value}>
							<ChakraCheckbox.HiddenInput />
							<ChakraCheckbox.Control />
							<ChakraCheckbox.Label>
								{item.label}
							</ChakraCheckbox.Label>
						</ChakraCheckbox.Root>
					))}
				</Fieldset.Content>
			</ChakraCheckboxGroup>
		</FormFieldset>
	);
};
